import uuidv4 from "uuid/v4";
import Vue from "vue";
import { ERequestType, fetchGetHelper, fetchPostHelper } from "../../tools/fetch";
import { compareTime, nextTime } from "../../tools/timeTool";

// GIT NOTE : git version d7f81b91 -> before remove subservices

/*************************************
 State
 **/
const state = {
	allEvents: {},
	selectedEvent: null,
	isLoaded: false,
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get all events of current resto
	 * @param {*} state
	 */
	getAllEvents: function (state) {
		return state.allEvents;
	},

	/**
	 * get selected Event
	 */
	getSelectedEvent: function (state) {
		// TODO: get correct data
		return state.selectedEvent;
	},

	/**
	 * Get number of interval in service
	 * @param {*} msSelect main service selected
	 * @param {*} dSelect day selected
	 */
	getNumberOfIntervalEvents: (state, getters) => (msSelect, dSelect) => {
		if (dSelect !== "order") {
			let tabHInter = [];
			let step = getters["getServiceFormInit"][msSelect][dSelect]["form"].intervalResa;
			let inter = nextTime(getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa, step);
			let id = 1;
			if (
				getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa !== getters["getServiceFormInit"][msSelect][dSelect]["form"].opening
			) {
				tabHInter.push({
					hour: getters["getServiceFormInit"][msSelect][dSelect]["form"].hMinTakeResa,
					id: id,
				});
				id += 1;
			}
			if (getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa) {
				while (compareTime(inter, getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa) < 0) {
					tabHInter.push({
						hour: inter,
						id: id,
					});
					inter = nextTime(inter, step);
					id += 1;
				}
				if (
					getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa !==
						getters["getServiceFormInit"][msSelect][dSelect]["form"].closing &&
					getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa !== getters["getServiceFormInit"][msSelect][dSelect]["form"].opening
				) {
					tabHInter.push({
						hour: getters["getServiceFormInit"][msSelect][dSelect]["form"].hMaxTakeResa,
						id: id,
					});
				}
			}
			return tabHInter;
		}
	},
	/**
	 * Get number of interval in service
	 * @param {*} msSelect main service selected
	 * @param {*} dSelect day selected
	 */
	getNumberOfIntervalEventsDyna: (state, getters) => (servciesDatas) => {
		let tabHInter = [];
		let step = servciesDatas.intervalResa;
		let inter = nextTime(servciesDatas.hMinTakeResa, step);
		let id = 1;

		const isHourInArray = (hour) => {
			return tabHInter.some((item) => item.hour === hour);
		};

		if (servciesDatas.hMinTakeResa !== servciesDatas.opening && !isHourInArray(servciesDatas.hMinTakeResa)) {
			tabHInter.push({
				hour: servciesDatas.hMinTakeResa,
				id: id,
			});
			id += 1;
		}
		if (servciesDatas.hMaxTakeResa) {
			while (compareTime(inter, servciesDatas.hMaxTakeResa) < 0) {
				if (!isHourInArray(inter)) {
					tabHInter.push({
						hour: inter,
						id: id,
					});
					id += 1;
				}
				inter = nextTime(inter, step);
			}
			if (
				servciesDatas.hMaxTakeResa !== servciesDatas.closing &&
				servciesDatas.hMaxTakeResa !== servciesDatas.opening &&
				!isHourInArray(servciesDatas.hMaxTakeResa)
			) {
				tabHInter.push({
					hour: servciesDatas.hMaxTakeResa,
					id: id,
				});
			}
		}
		return tabHInter;
	},

	/**
	 * get Service Form Init return service object formated with default values
	 */
	getServiceFormInit: function (state, getters) {
		let formatedData = {};
		formatedData["daysSortedById"] = [];
		// for each mainServices
		Object.entries(getters["getAllServices"]).forEach(([ms, valms]) => {
			formatedData[ms] = {};
			// for each days
			Object.entries(valms).forEach(([d, vald]) => {
				if (d !== "order") {
					let mainCapacity = vald.capacityIntervalMain;
					if (!mainCapacity || mainCapacity === "") mainCapacity = 0;
					formatedData[ms][d] = {};
					formatedData[ms][d]["form"] = {
						opening: vald.opening,
						closing: vald.closing,
						capacity: vald.capacity,
						capacityIntervalMain: mainCapacity,
						capacityIntervalTab: vald.capacityIntervalTab,
						hMaxTakeResa: vald.hMaxTakeResa,
						hMinTakeResa: vald.hMinTakeResa,
						intervalResa: vald.intervalResa,
						limitSecuChrono: vald.limitSecuChrono,
						limitAnnulation: vald.limitAnnulation,
						nbServices: vald.nbServices,
						lenghtService: vald.lenghtService,
						nbMaxByResa: vald.nbMaxByResa,
						nbMinByResa: vald.nbMinByResa,
						nbMaxResa: vald.nbMaxResa,
						closeAuto: vald.closeAuto,
						closeAutoTime: vald.closeAutoTime,
						cashOn: vald.cashOn,
						cashType: vald.cashType,
						cashPrice: vald.cashPrice,
						cashCouv: vald.cashCouv,
						cashLimitHour: vald.cashLimitHour,
						isClosed: vald.isClosed,
						invisible: vald.invisible,
						formIsOpen: false,
					};
					formatedData[ms][d]["label"] = d;
					formatedData[ms][d]["idDay"] = vald.idDay;
					formatedData[ms][d]["duplicate"] = "";
					// sort days
					if (formatedData["daysSortedById"][vald.idDay - 1] === undefined) {
						formatedData["daysSortedById"][vald.idDay - 1] = d;
					}
					if (!formatedData[ms][d]["form"].limitAnnulation) {
						formatedData[ms][d]["form"].limitAnnulation = "00:00";
					}
					if (formatedData[ms][d]["form"].nbMaxResa === undefined) {
						formatedData[ms][d]["form"].nbMaxResa = 0;
					}
					if (formatedData[ms][d]["form"].closeAuto === undefined) {
						formatedData[ms][d]["form"].closeAuto = false;
					}
					if (formatedData[ms][d]["form"].cashOn === undefined) {
						formatedData[ms][d]["form"].cashOn = false;
					}
					if (!formatedData[ms][d]["form"].closeAutoTime) {
						formatedData[ms][d]["form"].closeAutoTime = "00:00";
					}
				}
			});
		});
		return formatedData;
	},

	/**
	 * get Service datas is loaded
	 */
	getEventsIsLoaded: function (state) {
		return state.isLoaded;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	/**
	 * set all services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setAllEvents(state, dbData) {
		state.allEvents = dbData;
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	setSelectedEvent(state, dbData) {
		state.selectedEvent = dbData;
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	clearSelectedEvent(state) {
		Vue.set(state, "selectedEvent", null);
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	setSelectedEventById(state, searchId) {
		state.selectedEvent = state.allEvents.find((el) => el.id === searchId);
	},

	/**
	 * set loaded store state
	 * @param {*} state
	 * @param {*} val
	 */
	setLoadedState(state, val) {
		state.isLoaded = val;
	},

	/**
	 * reset store
	 * @param {*} state
	 */
	resetStore(state) {
		state.allEvents = {};
		state.selectedEvent = {};
		state.isLoaded = false;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Clean store
	 * @param {*} store params
	 */
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},

	/**
	 * Create Main service
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  name
	 *  order
	 * }
	 */
	createEvent: function ({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		// TODO: check if Events all ready exist on same day date and hours
		let found = false;
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		return new Promise((resolve, reject) => {
			// if already reject
			if (found) {
				reject(new Error("Le service exist déjà"));
			} else {
				// else create service
				let newId = `${payload.name.toLowerCase().replace(/[^A-Z0-9]+/gi, "_")}_${uuidv4()}`;
				if (state.selectedEvent) newId = state.selectedEvent.id;

				let labelDays = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
				let selectDays = payload.days;
				let servicesDays = {};
				// init servicesDays to empty
				labelDays.forEach((day) => {
					servicesDays[day] = {};
				});
				// if days setted set service for days
				if (selectDays.length > 0) {
					selectDays.forEach((day) => {
						servicesDays[day] = Object.assign({}, payload.services);
					});
				} else {
					// if days not setted
					// get number of days not setted
					let startDate = new Date(payload.dates[0]);
					let endDate = new Date(payload.dates[1]);
					// get nb day
					let nbDays = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24));
					// if nb days is equal to one week populate service
					if (nbDays > 6) {
						labelDays.forEach((day) => {
							servicesDays[day] = Object.assign({}, payload.services);
							selectDays.push(day);
						});
					} else {
						// just populate days between the two dates
						let curDate = new Date(startDate.getTime());
						while (curDate.getTime() <= endDate.getTime()) {
							let dayOfWeek = curDate.getDay();
							selectDays.push(labelDays[dayOfWeek]);
							servicesDays[labelDays[dayOfWeek]] = Object.assign({}, payload.services);
							curDate.setDate(curDate.getDate() + 1);
						}
					}
				}

				let newEvent = {
					restoid: uid,
					name: payload.name,
					title: payload.title,
					desc: payload.desc,
					visible: payload.visible,
					id: newId || `${payload.name.toLowerCase().replace(/[^A-Z0-9]+/gi, "_")}_${uuidv4()}`,
					days: selectDays,
					dates: payload.dates,
					services: servicesDays,
				};

				// send datas to db
				fetchPostHelper(ERequestType.EVENTS.CREATE, newEvent, userDatas.token)
					.then((res) => {
						dispatch("loadEventsStore");
						dispatch("newServices/loadServicesStore", false, { root: true });
						resolve(res.data);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
		});
	},

	/**
	 * remove main services
	 * @param {*} payload:Object {
	 *  - name: string,
	 *  - id: string
	 * }
	 */
	async deleteEventById({ state, rootState, commit, dispatch, getters, rootGetters }, payload) {
		let userDatas = rootGetters["newUsers/getUser"];

		let eventToDelete = state.allEvents.find((el) => el.id === payload);
		// delete on db
		return new Promise(async (resolve, reject) => {
			await fetchPostHelper(ERequestType.EVENTS.DELETE, eventToDelete, userDatas.token)
				.then(async (res) => {
					dispatch("loadEventsStore");
					dispatch("newServices/loadServicesStore", false, { root: true });
					resolve();
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadEventsStore: function ({ state, rootState, commit, dispatch, getters, rootGetters }) {
		// get all datas for db
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.EVENTS.ALL, `restoid=${uid}`)
				.then((res) => {
					// if no services found
					if (res.data.length === 0) {
						commit("setAllEvents", {});
						commit("setSelectedEvent", {});
						commit("setLoadedState", true);
						resolve();
						return;
					}
					commit("setAllEvents", res.data);

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadEventsStoreVisible: function ({ state, rootState, commit, dispatch, getters, rootGetters }) {
		// get all datas for db
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.EVENTS.VISIBLE, `restoid=${uid}`)
				.then((res) => {
					// if no services found
					if (res.data.length === 0) {
						commit("setAllEvents", {});
						commit("setSelectedEvent", {});
						commit("setLoadedState", true);
						resolve();
						return;
					}
					commit("setAllEvents", res.data);

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
